import type { IconNode } from '../types';

/**
 * @name mustache
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTguMiA4LjZhMy45IDMuOSAwIDAgMC02LjItLjIgMy43NSAzLjc1IDAgMCAwLTYuMi4ybC0uNi44QzQuNSAxMC40IDMuMyAxMSAyIDExYTUuNTUgNS41NSAwIDAgMCAxMCAzLjJBNS40NSA1LjQ1IDAgMCAwIDIyIDExYy0xLjMgMC0yLjUtLjYtMy4yLTEuNloiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/mustache
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const mustache: IconNode = [
  [
    'path',
    {
      d: 'M18.2 8.6a3.9 3.9 0 0 0-6.2-.2 3.75 3.75 0 0 0-6.2.2l-.6.8C4.5 10.4 3.3 11 2 11a5.55 5.55 0 0 0 10 3.2A5.45 5.45 0 0 0 22 11c-1.3 0-2.5-.6-3.2-1.6Z',
      key: '1e29zc',
    },
  ],
];

export default mustache;
